export default "__VITE_ASSET__CjKffKiO__"